import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonLibraryFeedOverview, CommonLibraryFeedTopics } from "../../CommonComponents/CommonLibraryFeedViews";

export const LibraryFeedRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.feed.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryFeedOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryFeedTopics />;
    }
};
